var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.institution && !_vm.institution.kl_assessment)?[_c('Page404')]:[_c('NewEvaluation',{attrs:{"allows_crud":false,"evaluation_id":_vm.evaluation_id,"instrument_id":_vm.instrument_id,"evaluatee_view":true}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }